import { FunctionComponent } from 'react';
import { VGDisclaimerFooter } from '../../../components/VGDisclaimerFooter/VGDisclaimerFooter';
import { trackDisclaimerModalOpen } from '../../../analytics/event-tracking/trackDisclaimerModalOpen';
import { useSuburbPageModalContext } from '../../contexts/SuburbPageModalContext/SuburbPageModalContext';
import { styled } from 'styled-components';
import { mediaHelper, spacingHelper } from '@property.com.au/ui-kit';

const Wrapper = styled.div`
  ${mediaHelper('tabletMax')} {
    padding: 0 ${spacingHelper('extraSmall')};
  }
`;

export const SuburbPageVGDisclaimerFooter: FunctionComponent = () => {
  const { displayModal } = useSuburbPageModalContext();

  return (
    <Wrapper>
      <VGDisclaimerFooter
        onDisclaimerLinkClick={() => {
          displayModal({ name: 'vgDisclaimer' });
          trackDisclaimerModalOpen({
            inPageSource: ['suburb_page', 'footer_disclaimer', 'button'].join('__'),
          });
        }}
      />
    </Wrapper>
  );
};
